import { baseConfigs } from './environment.base';

export const environment = {
  production: false,
  baseConfigs,
  randomPtsPhxUrl:
    'https://mfcallahan-homepage-dev.azurewebsites.net/api/MockData/RandomPointsPhx',
};
